
const digest = '1eb0d593ae2753cc00085d8e551c2031035755a8ee4aaccbffefb8e315773345';
const classes = {"title":"_title_18n8y_1","radioWrapper":"_radioWrapper_18n8y_9","fieldsWrapper":"_fieldsWrapper_18n8y_13","fieldSeparator":"_fieldSeparator_18n8y_26","numberField":"_numberField_18n8y_31","field":"_field_18n8y_13","removeItemWrapper":"_removeItemWrapper_18n8y_48","antiDFieldsWrapper":"_antiDFieldsWrapper_18n8y_55","suffix":"_suffix_18n8y_61"};
const css = `._title_18n8y_1 {
  font-family: Rubik, sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #000;
  margin: 16px 0 !important;
}

._radioWrapper_18n8y_9 {
  width: fit-content;
}

._fieldsWrapper_18n8y_13 {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  margin-bottom: 16px;
  flex: 1;
}
@media (min-width: 1400px) {
  ._fieldsWrapper_18n8y_13 {
    grid-template-columns: 1fr 1fr auto;
    grid-gap: 32px;
  }
}
._fieldsWrapper_18n8y_13._fieldSeparator_18n8y_26 {
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

._numberField_18n8y_31 {
  /* Chrome, Safari, Edge, Opera */
  /* Firefox */
}
._numberField_18n8y_31 input::-webkit-outer-spin-button,
._numberField_18n8y_31 input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
._numberField_18n8y_31 input[type=number] {
  -moz-appearance: textfield;
}

._field_18n8y_13 {
  margin-top: 8px;
}

._removeItemWrapper_18n8y_48 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 55px;
}

._antiDFieldsWrapper_18n8y_55 {
  display: flex;
  gap: 18px;
  margin-top: 8px;
}

._suffix_18n8y_61 {
  margin-bottom: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  